import { useAbility } from 'src/permissions/hooks/useAbility';

export const useSimProfileDetailsAvaibility = () => {
  const ability = useAbility();
  return ability.can('read', 'simDetails');
};
